import { DetailedHTMLProps, HTMLAttributes } from "react";
import { brand } from "shared/config";
import { LogoClocksterIcon } from "../icons";

export const AppLogo = ({
  style,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  if (brand.key === "clockster") {
    return (
      <div style={{ textAlign: "center", ...style }} {...props}>
        <LogoClocksterIcon />
      </div>
    );
  }

  return (
    <div
      style={{
        fontFamily: '"Syne", sans-serif',
        fontSize: 28,
        fontWeight: 800,
        letterSpacing: -0.5,
        color: "var(--ant-color-primary)",
        textAlign: "center",
        ...style,
      }}
      {...props}
    >
      AKJET
    </div>
  );
};
